import 'jquery.actual';
import 'jquery-sticky-kit';
import 'vanilla-sharing';
import 'moment/locale/en-il';
import Swiper from 'swiper';
import moment from 'moment';
import autoComplete from 'pixabay-javascript-autocomplete';

global.moment = moment;
global.Swiper = Swiper;
global.autoComplete = autoComplete;